// Debug utilities for the wizard

export function enableWizardDebug() {
  if (typeof window === 'undefined') return;
  
  // Add debug functions to window object
  (window as any).__wizardDebug = {
    // Get current wizard state
    getState: () => {
      const wizardState = document.querySelector('[data-wizard-state]');
      return wizardState ? JSON.parse(wizardState.getAttribute('data-wizard-state') || '{}') : null;
    },
    
    // Force render a specific step
    forceStep: (step: string) => {
      console.log(`[DEBUG] Forcing step to: ${step}`);
      window.dispatchEvent(new CustomEvent('wizard:forceStep', { detail: { step } }));
    },
    
    // Show all environment variables
    showEnv: () => {
      console.log('[DEBUG] Environment Variables:');
      console.log('NODE_ENV:', process.env.NODE_ENV);
      console.log('All NEXT_PUBLIC vars:', Object.keys(process.env).filter(k => k.startsWith('NEXT_PUBLIC_')));
    },
    
    // Check wizard component mounting
    checkMounting: () => {
      const elements = {
        wizardContainer: document.querySelector('[data-wizard-container]'),
        stepIndicator: document.querySelector('[data-step-indicator]'),
        stepContent: document.querySelector('[data-step-content]'),
        errorBoundary: document.querySelector('[data-error-boundary]'),
      };
      
      console.log('[DEBUG] Mounted Elements:', elements);
      console.log('[DEBUG] Wizard Container Classes:', elements.wizardContainer?.className);
      console.log('[DEBUG] Step Content HTML:', elements.stepContent?.innerHTML.substring(0, 200));
      
      return elements;
    },
    
    // Enable verbose logging
    enableVerboseLogging: () => {
      localStorage.setItem('wizard:debug', 'true');
      console.log('[DEBUG] Verbose logging enabled. Refresh page to see all logs.');
    },
    
    // Disable verbose logging
    disableVerboseLogging: () => {
      localStorage.removeItem('wizard:debug');
      console.log('[DEBUG] Verbose logging disabled.');
    },
    
    // Show current form values
    showFormValues: () => {
      const formElement = document.querySelector('form');
      if (formElement) {
        const formData = new FormData(formElement);
        const values: Record<string, any> = {};
        formData.forEach((value, key) => {
          values[key] = value;
        });
        console.log('[DEBUG] Form Values:', values);
        return values;
      }
      console.log('[DEBUG] No form element found');
      return null;
    },
    
    // Test render of a component
    testRender: () => {
      const testDiv = document.createElement('div');
      testDiv.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:red;color:white;padding:20px;z-index:99999;';
      testDiv.innerHTML = '<h1>TEST RENDER SUCCESSFUL</h1><p>If you see this, React is rendering.</p>';
      document.body.appendChild(testDiv);
      setTimeout(() => testDiv.remove(), 3000);
    }
  };
  
  console.log(`
    🧪 WIZARD DEBUG ENABLED 🧪
    
    Available commands:
    - __wizardDebug.getState() - Get current wizard state
    - __wizardDebug.forceStep('step-name') - Force a specific step
    - __wizardDebug.showEnv() - Show environment variables
    - __wizardDebug.checkMounting() - Check mounted elements
    - __wizardDebug.enableVerboseLogging() - Enable verbose logs
    - __wizardDebug.disableVerboseLogging() - Disable verbose logs
    - __wizardDebug.showFormValues() - Show current form values
    - __wizardDebug.testRender() - Test if rendering works
  `);
}

// Auto-enable debug if localStorage flag is set or URL has debug=true
if (typeof window !== 'undefined') {
  if (localStorage.getItem('wizard:debug') === 'true' || window.location.search.includes('debug=true')) {
    enableWizardDebug();
  }
}
